// NavItems.js

import { faHouse, faGear, faCircleInfo, faClipboard, faGraduationCap, faUser } from '@fortawesome/free-solid-svg-icons';

const navItems = [
  { name: 'Dashboard', icon: faHouse },
  { name: 'Quizzes', icon: faClipboard },
  { name: 'Mock Exams', icon: faGraduationCap },
  { name:'Profile', icon: faUser },
  { name: 'Settings', icon: faGear },
  { name: 'Support', icon: faCircleInfo },
  // Add more navigation links as needed
];

export default navItems;
